import React from 'react';
import { useTranslation } from 'react-i18next';

const TermsAndConditions = () => {
    const { t } = useTranslation();

    return (
        <div className="container mx-auto px-4 py-8 max-w-4xl">
            <h1 className="text-3xl font-bold mb-8">{t('termsAndConditions')}</h1>
            
            {/* 1. Introduction */}
            <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">1. {t('introduction')}</h2>
                <p className="text-gray-700 leading-relaxed">
                    {t('termsIntro')}
                </p>
            </section>

            {/* 2. User Responsibilities */}
            <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">2. {t('userResponsibilities')}</h2>
                <div className="space-y-4">
                    <div>
                        <h3 className="text-xl font-semibold mb-2">{t('userResponsibilitiesItems.condition.title')}</h3>
                        <p className="text-gray-700">{t('userResponsibilitiesItems.condition.desc')}</p>
                    </div>
                    <div>
                        <h3 className="text-xl font-semibold mb-2">{t('userResponsibilitiesItems.honesty.title')}</h3>
                        <p className="text-gray-700">{t('userResponsibilitiesItems.honesty.desc')}</p>
                    </div>
                    <div>
                        <h3 className="text-xl font-semibold mb-2">{t('userResponsibilitiesItems.security.title')}</h3>
                        <p className="text-gray-700">{t('userResponsibilitiesItems.security.desc')}</p>
                    </div>
                </div>
            </section>

            {/* 3. Book Transactions */}
            <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">3. {t('bookTransactionsTerms')}</h2>
                <div className="space-y-4">
                    <div>
                        <h3 className="text-xl font-semibold mb-2">{t('bookTransactionsItems.sending.title')}</h3>
                        <p className="text-gray-700">{t('bookTransactionsItems.sending.desc')}</p>
                    </div>
                    <div>
                        <h3 className="text-xl font-semibold mb-2">{t('bookTransactionsItems.validation.title')}</h3>
                        <p className="text-gray-700">{t('bookTransactionsItems.validation.desc')}</p>
                    </div>
                    <div>
                        <h3 className="text-xl font-semibold mb-2">{t('bookTransactionsItems.pricing.title')}</h3>
                        <p className="text-gray-700">{t('bookTransactionsItems.pricing.desc')}</p>
                    </div>
                </div>
            </section>

            {/* 4. Wallet Usage Rules */}
            <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">4. {t('walletRules')}</h2>
                <div className="space-y-4">
                    <div>
                        <h3 className="text-xl font-semibold mb-2">{t('walletRulesItems.balance.title')}</h3>
                        <p className="text-gray-700">{t('walletRulesItems.balance.desc')}</p>
                    </div>
                    <div>
                        <h3 className="text-xl font-semibold mb-2">{t('walletRulesItems.usage.title')}</h3>
                        <p className="text-gray-700">{t('walletRulesItems.usage.desc')}</p>
                    </div>
                    <div>
                        <h3 className="text-xl font-semibold mb-2">{t('walletRulesItems.refunds.title')}</h3>
                        <p className="text-gray-700">{t('walletRulesItems.refunds.desc')}</p>
                    </div>
                </div>
            </section>

            {/* 5. Refund Policy */}
            <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">5. {t('refundPolicy')}</h2>
                <div className="space-y-4">
                    <div>
                        <h3 className="text-xl font-semibold mb-2">{t('refundPolicyItems.purchases.title')}</h3>
                        <p className="text-gray-700">{t('refundPolicyItems.purchases.desc')}</p>
                    </div>
                    <div>
                        <h3 className="text-xl font-semibold mb-2">{t('refundPolicyItems.process.title')}</h3>
                        <p className="text-gray-700">{t('refundPolicyItems.process.desc')}</p>
                    </div>
                </div>
            </section>

            {/* 6. Limitation of Liability */}
            <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">6. {t('liability')}</h2>
                <p className="text-gray-700">{t('liabilityDesc')}</p>
            </section>

            {/* 7. Changes to Terms */}
            <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">7. {t('changes')}</h2>
                <p className="text-gray-700">{t('changesDesc')}</p>
            </section>

            {/* 8. Governing Law */}
            <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">8. {t('law')}</h2>
                <p className="text-gray-700">{t('lawDesc')}</p>
            </section>
        </div>
    );
};

export default TermsAndConditions; 